import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import './AddToCartNotification.css';

const AddToCartNotification = () => {
  const { showNotification } = useCart();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (showNotification) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  if (!isVisible) return null;

  return (
    <div className="add-to-cart-notification">
      <div className="notification-content">
        <span className="notification-icon">✅</span>
        <span className="notification-text">Added to cart!</span>
      </div>
    </div>
  );
};

export default AddToCartNotification; 